import { Icon } from '@livable/saas-react-components';
import { Box, Chip, Container, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
const basicStatusExample = "\n<Chip label=\"Inactive\" variant=\"inactive\" />\n\nvariants: inactive, info, warning, success, critical, button\n";
const basicDropdownExample = "\n<Chip label=\"Inactive\" icon={<Icon type=\"triangle-down\" />} variant=\"inactiveDropdown\" />\n\nvariants: inactiveDropdown, infoDropdown, warningDropdown, successDropdown, criticalDropdown\n";
const balanceStatusExample = "\n<Chip icon={<Icon type=\"success\" />} variant=\"successIcon\" />\n\nvariants: successIcon, warningIcon, criticalIcon, infoIcon, greyIcon\n\n<Chip label=\"Balance OK\" icon={<Icon type=\"success\" />} variant=\"success\" />\n\nvariants: success, warning, critical, info\n\n<Chip label=\"Balance OK\" icon={<Icon type=\"success\" />} variant=\"successPlain\" />\n\nvariants: successPlain, warningPlain, criticalPlain, infoPlain\n";
const portalStatusExample = "\n<Chip icon={<Icon type=\"access-key\" />} variant=\"successIcon\" />\n\nvariants: successIcon, warningIcon, criticalIcon, infoIcon, inactiveIcon\n\n<Chip label=\"Has portal access\" icon={<Icon type=\"access-key\" />} variant=\"success\" />\n\nvariants: success, warning, critical, info\n\n<Chip label=\"Has portal access\" icon={<Icon type=\"access-key\" />} variant=\"successPlain\" />\n\nvariants: successPlain, warningPlain, criticalPlain, infoPlain\n";
const emailStatusExample = "\n<Chip icon={<Icon type=\"mail-success\" />} variant=\"successIcon\" />\n\nvariants: successIcon, warningIcon, criticalIcon, infoIcon, inactiveIcon, greyIcon\n\n<Chip label=\"Active\" icon={<Icon type=\"mail-success\" />} variant=\"success\" />\n\nvariants: success, warning, critical, info, inactive\n\n<Chip label=\"Active\" icon={<Icon type=\"mail-success\" />} variant=\"successPlain\" />\n\nvariants: successPlain, warningPlain, criticalPlain, infoPlain, inactivePlain\n";
const buildingStatusExample = "\n<Chip icon={<Icon type=\"building\" />} variant=\"successIcon\" />\n\nvariants: successIcon, warningIcon, criticalIcon, infoIcon, inactiveIcon, greyIcon\n";
const groupStatusExample = "\n<Chip icon={<Icon type=\"property\" />} variant=\"successIcon\" />\n\nvariants: successIcon, warningIcon, criticalIcon, infoIcon, inactiveIcon\n";
export default function LvStatus() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, /*#__PURE__*/React.createElement("span", null, "Status "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-chip/",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Basic Simple"), /*#__PURE__*/React.createElement(Chip, {
    label: "Inactive",
    variant: "inactive"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Draft",
    variant: "info"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    variant: "warning"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Active",
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Critical",
    variant: "critical"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Button",
    variant: "button"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, basicStatusExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Basic Dropdown"), /*#__PURE__*/React.createElement(Chip, {
    label: "Inactive",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }),
    variant: "inactiveDropdown"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Draft",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }),
    variant: "infoDropdown"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }),
    variant: "warningDropdown"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Active",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }),
    variant: "successDropdown"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Critical",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }),
    variant: "criticalDropdown"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, basicDropdownExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Balance status")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Balance OK",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    }),
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Balance OK",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    }),
    variant: "successPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "warningIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Due approaching",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    }),
    variant: "warning"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Due approaching",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    }),
    variant: "warningPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "criticalIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Overdue 5 days",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "critical"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Overdue 5 days",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "criticalPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "coin-copper"
    }),
    variant: "infoIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Net Zero Billing",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "coin-copper"
    }),
    variant: "info"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Net Zero Billing",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "coin-copper"
    }),
    variant: "infoPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, balanceStatusExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Portal status")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Has portal access",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Has portal access",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "successPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "warningIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "warning"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "warningPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "criticalIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    label: "Re-invite",
    variant: "critical"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Re-invite",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "criticalPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "infoIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    label: "Add email",
    variant: "info"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    label: "Add email",
    variant: "infoPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }),
    variant: "inactiveIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Closed",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }),
    variant: "inactive"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Closed",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }),
    variant: "inactivePlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, portalStatusExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Email status")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-success"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Active",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-success"
    }),
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Active",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-success"
    }),
    variant: "successPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-send"
    }),
    variant: "warningIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-send"
    }),
    variant: "warning"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-send"
    }),
    variant: "warningPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-error"
    }),
    variant: "criticalIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Re-invite",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-error"
    }),
    variant: "critical"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Re-invite",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-error"
    }),
    variant: "criticalPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail"
    }),
    variant: "infoIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "No email",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail"
    }),
    variant: "info"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "No email",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail"
    }),
    variant: "infoPlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipsContainer
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-locked"
    }),
    variant: "inactiveIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Inactive",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-locked"
    }),
    variant: "inactive"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Inactive",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-locked"
    }),
    variant: "inactivePlain"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, emailStatusExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Building status"), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "building-empty"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "clock"
    }),
    variant: "warningIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }),
    variant: "infoIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "inactiveIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "criticalIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "greyIcon"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, buildingStatusExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Group status"), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "property"
    }),
    variant: "successIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "property"
    }),
    variant: "warningIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "property"
    }),
    variant: "infoIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "property"
    }),
    variant: "inactiveIcon"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "criticalIcon"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, groupStatusExample))))));
}